"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TOTPCodeInput = exports.SMSCodeInput = exports.RecoveryCodeInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _vanillaTextMask = _interopRequireDefault(require("vanilla-text-mask"));
var _Input = _interopRequireDefault(require("../../components/Input"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MaskInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  (0, _react.useEffect)(function () {
    var maskedInputCdontroller = (0, _vanillaTextMask["default"])({
      inputElement: ref.current,
      mask: props.mask,
      placeholderChar: "\u2000"
    });
    return function () {
      maskedInputCdontroller.destroy();
    };
  }, [props.mask]);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, props, {
    ref: ref
  }));
});
var _default = exports["default"] = MaskInput;
var TOTPCodeInput = exports.TOTPCodeInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(MaskInput, (0, _extends2["default"])({
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
  }, props, {
    ref: ref
  }));
});
var SMSCodeInput = exports.SMSCodeInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(MaskInput, (0, _extends2["default"])({
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
  }, props, {
    ref: ref
  }));
});
var RecoveryCodeInput = exports.RecoveryCodeInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(MaskInput, (0, _extends2["default"])({
    mask: [/[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/, /[a-z]/]
  }, props, {
    ref: ref
  }));
});
//# sourceMappingURL=MaskInput.js.map